export const TABS_SETTINGS = {
  GlobalMain: [
    { id: 'IASBProjects', title: 'IASB projects' },
    { id: 'IASBResearch', title: 'IASB research' },
    { id: 'ISSBProjects', title: 'ISSB projects' },
    { id: 'ISSBResearch', title: 'ISSB research' },
    { id: 'PastProjects', title: 'Past projects' },
    { id: 'PastFRCProjects', title: 'Past FRC projects' },
    { id: 'PastIFRSProjects', title: 'Past IFRS projects' },
  ],
  UKMain: [
    { id: 'FRCProjects', title: 'FRC projects' },
    { id: 'FRCResearch', title: 'FRC research' },
    { id: 'PastFRCProjects', title: 'Past FRC projects' },
    { id: 'PastIFRSProjects', title: 'Past IFRS projects' },
    { id: 'PastProjects', title: 'Past projects' },
  ],
};


export enum E_VIEWLET_TYPE {
  GlobalMain = 'GlobalMain',
  GlobalSubPagesType1 = 'GlobalSubPagesType1',
  GlobalSubPagesType2 = 'GlobalSubPagesType2',
  UKMain = 'UKMain',
  Canada = 'Canada',
}

export enum E_VIEWLET_TYPE_INDEX {
  None = 0,
  GlobalMain = 1,
  GlobalSubPagesType1 = 2,
  GlobalSubPagesType2 = 3,
  UKMain = 4,
  Canada = 5
}

export enum E_PROJECT_STATUS {
  None = 0,
  IASBProjects = 1,
  IASBResearch = 2,
  ISSBProjects = 3,
  ISSBResearch = 4,
  Active = 5,
  Research = 6,
  FRCProjects = 7,
  FRCResearch = 8,
  PastProjects = 9,
  PastFRCProjects = 10,
  PastIFRSProjects = 11
}
